import React from 'react'
const utilityFormFields = [
  {
    id:"profile",
    name:"profile",
    label:"Profile*",
    type:"text",
  },
  {
    id:"baseUrl",
    name:"baseUrl",
    label:"Base URL*",
    type:"text",
  },
  {
    id:"dcapPath",
    name:"dcapPath",
    label:"Dcap Path*",
    type:"text",
  },
  {
    id: 'headerMediaType',
    name: 'headerMediaType',
    label: 'Header Media Type*',
    type: 'text',
  },
  {
    id: 'notificationBaseUrl',
    name: 'notificationBaseUrl',
    label: 'Notification Base URL',
    type: 'text',
  },
  {
    id:"derControlPollSeconds",
    name:"derControlPollSeconds",
    label:"Poll Seconds*",
    type:"number",
  },
  {
    id:'outOfBandPin',
    name:'outOfBandPin',
    label:'Out Of Band PIN',
    type:'text',
  },
  {
    id:'country',
    name:'country',
    label:'Country',
    type:'dropdown',
  },
  {
    id:'derControlPollerActive',
    name:"derControlPollerActive",
    label:"Der Control Poller Active",
    type:"switch",
  },
  {
    id: 'fetchOnlyVirtualDerControls',
    name:"fetchOnlyVirtualDerControls",
    label:"Fetch Only Virtual Der Controls",
    type:"switch",
  }, 
  {
    id: 'enableNotification',
    name: 'enableNotification',
    label: 'Enable Notification',
    type: 'switch',
  },
  {
    id: 'penAsDecimal',
    name: 'penAsDecimal',
    label: 'Pen As Decimal',
    type: 'switch',
  },
  {
    id: 'matchUTCTick',
    name: 'matchUTCTick',
    label: 'Match UTC Tick',
    type: 'switch',
  },
  {
    id: 'nepkiCompliant',
    name: 'nepkiCompliant',
    label: 'NEPKI Compliant',
    type: 'switch',
  },
  {
    id: 'outOfBandPinValidationDisabled',
    name: 'outOfBandPinValidationDisabled',
    label: 'Out Of Band PIN Validation Disabled',
    type: 'switch',
  },
  {
    id: 'mirrorReadingSetSupported',
    name: 'mirrorReadingSetSupported',
    label: 'Mirror Reading Set Supported',
    type: 'switch',
  },
  {
    id: 'validateMMREligibility',
    name: 'validateMMREligibility',
    label: 'Validate MMR Eligibility',
    type: 'switch',
  },
  {
    id: 'clampOpmodeZeroToOne',
    name: 'clampOpmodeZeroToOne',
    label: 'Convert OpMode 0 to 1',
    type: 'switch',
  },
  {
    id: 'passClientCertForServerCertValidation',
    name: 'passClientCertForServerCertValidation',
    label: 'Pass Client Cert For Server Cert Validation',
    type: 'switch',
  }
]

export default utilityFormFields